import SubscriptionComparisonTable from './SubscriptionComparisonTable';

export default SubscriptionComparisonTable;
